import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="shared--app-new-item"
//
// In the mobile app, wires the native "+" (new item) button in the app bar to
// this element's href via the JS bridge. Used e.g. on the profile page so the
// native "+" opens a new message to that member (recipient pre-filled via the
// URL). No-op on the web.
//
// NOTE: the native app currently only renders the "+" on main list screens,
// not on pushed detail pages. The call is harmless until native support for
// detail pages lands.
export default class extends Controller {
  connect() {
    const url = this.element.getAttribute("href");
    if (!window.isApp || !url) return;
    window.bridge?.setNewItemButton(url);
  }

  // Clear the native "+" on teardown so it doesn't linger into the next page
  // (stale-state class of tixxt-turbo-apps#199); the next screen sets its own.
  disconnect() {
    if (window.isApp) window.bridge?.setNewItemButton("");
  }
}
